module.exports = __webpack_public_path__ + "img/img55.606b159e.png";